import { createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { setCategories } from "store/slices/dialogs/createEvent.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncQueries = {
    getCreateEventCategories: createAppAsyncThunk(
      "createEvent/getCreateEventCategories",
      async (_, { rejectWithValue, extra: { sdk }, dispatch }) => {
        try {

          const { data, errors } = await graphqlRequest(sdk.getCreateEventCategories);
  
          if (errors) return rejectWithValue(errors);
  
          if (!data?.createEventOptions) {
            console.error("Error: No createEventOptions found in the response.");
            return rejectWithValue("Something went wrong");
          }
  
          const { categories } = data.createEventOptions || {};
  
          if (categories) {
            const transformedCategories = categories.map((category) => ({
              id: category.id ?? 0, 
              text: category.text ?? "", 
              typeId: category.typeId ?? 0, 
            }));
  
            dispatch(setCategories(transformedCategories));
            return { categories: transformedCategories };
          }
  
          console.error("Error: Categories not found.");
          return rejectWithValue("Something went wrong");
        } catch (error) {
          console.error("Unexpected error while fetching categories:", error);
          return rejectWithValue("Unexpected error occurred");
        }
      }
    ),
  };
